export default "__VITE_ASSET__c163f652__"